import { useDynamicConfig } from "@statsig/react-bindings";

import { ADS_COOKIE_BANNER_ROLLOUT_CONFIG, normalizeCountryCode } from "./cookieConsent";

export const ADS_CONVERSION_SHARING_COUNTRY_FIELDS = {
  google: "google_all_sharing_countries",
  meta: "meta_all_sharing_countries",
  linkedin: "linkedin_all_sharing_countries",
  reddit: "reddit_all_sharing_countries",
} as const;

type AdsConversionSharingPlatform = keyof typeof ADS_CONVERSION_SHARING_COUNTRY_FIELDS;

export function useAdsConversionSharingCountry(
  platform: AdsConversionSharingPlatform,
  countryCode: string | undefined,
): boolean {
  const config = useDynamicConfig(ADS_COOKIE_BANNER_ROLLOUT_CONFIG);
  const configuredCountries = config.get(ADS_CONVERSION_SHARING_COUNTRY_FIELDS[platform], []);
  return isAdsConversionSharingCountry(countryCode, configuredCountries);
}

export function isAdsConversionSharingCountry(
  countryCode: string | undefined,
  configuredCountries: unknown,
): boolean {
  const normalizedCountryCode = normalizeCountryCode(countryCode);
  if (normalizedCountryCode == null || !isWellFormedCountryCodeList(configuredCountries)) {
    return false;
  }

  return configuredCountries.some(
    (configuredCountry) => normalizeCountryCode(configuredCountry) === normalizedCountryCode,
  );
}

function isWellFormedCountryCodeList(value: unknown): value is string[] {
  return (
    Array.isArray(value) &&
    value.every(
      (countryCode) => typeof countryCode === "string" && normalizeCountryCode(countryCode) != null,
    )
  );
}
